<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="invenselect" :lablewith="item.lablewith" :options="item.options"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup :chackbox="chackbox" ref="btngroup" checked :show="showorhide"
						@showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Inventorylist @StockEdit="StockEdit" @StockExport="StockExport" @StockExportDay="StockExportDay" @onRowClick="onRowClick"
					:tableData="tableData" :total="total" :selectedRow="selectedRow" @handleCurrentChange="handleCurrentChange"
					@handleSizeChange="handleSizeChange"></Inventorylist>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
			<DialogFrom width="500px" title="修改" :dialogVisible="editDialogVisible" @cancel="editDialogVisible = false" @dialogOK="submitEdit">
				<div class="from" style="padding: 20px 0;">
					<div v-for="(item, index) in editFormFields" :key="index" style="margin-bottom: 10px;">
						<Commondropdownlist
							ref="editFormDropdowns"
							:title="item.title"
							:inputtype="item.inputtype"
							:types="item.types"
							:disabled="item.disabled"
							:width="item.width"
							:lablewith="item.lablewith"
							:inputdata="item.inputdata"
						></Commondropdownlist>
					</div>
				</div>
			</DialogFrom>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import DialogFrom from '../../../components/dialog-from.vue'
	import Inventorylist from './components/inventorylisttable.vue'
	import utils from '../../../common/utils'
	import {
		StockReportStockList,
		InventoryClassList,
		StockReportStockExport,
		StockReportStockDayExport,
		GetProvince,
		StockReportEdit
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			DialogFrom,
			Inventorylist
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				chackbox: true,
				formdata: [{
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '220px',
						options: [{
								key: "1",
								value: "一级经销商"
							},
							{
								key: "2",
								value: "二级经销商"
							},
						],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '经销商名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},

					{
						inputdata: '',
						title: '仓库编号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '220px',
						options: [

						],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '省份',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '220px',
						options: [],
						lablewith: '100px'
					},
					{
						inputdata: '',
						title: '销售',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '210px',
						lablewith: '100px'
					},
					{
						inputdata: "",
						title: "有效期区间",
						fontSize: "14px",
						color: "#333333",
						placeholder: "",
						types: "",
						inputtype: "date",
						width: "180px",
						widths: "210px",
						lablewith: "95px"
					}
				],
				editDialogVisible: false,
				editLoading: false,
				editFormFields: [],
				selectedRow: null,
				fromdatalist: [],
				from: {
					cusGrade: "",
					cusName: "",
					inventory: "",
					batch: "",
					invClass: "",
					isAboveZero: "",
					ProvinceID: "",
					ValiDate1: "",
					ValiDate2: "",
				},
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			//this.StockReportStockList()
			this.inventoryClassList()
			this.getProvince();
		},
		methods: {
			// 列表
			async StockReportStockList() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await StockReportStockList({
					cusGrade: this.from.cusGrade,
					cusName: this.from.cusName,
					inventory: this.from.inventory,
					batch: this.from.batch,
					invClass: this.from.invClass,
					isAboveZero: this.from.isAboveZero,
					ProvinceIDs: this.from.ProvinceID,
					SalesMan: this.from.SalesMan,
					ValiDate1: this.from.ValiDate1,
					ValiDate2: this.from.ValiDate2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				// //console.log(code, data.data)
				if (code == 0) {
					loading.close();
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
				} else {
					loading.close();
				}
			},
			//省份列表
			async getProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				console.log(data, '省');
				if (code == 0) {
					this.formdata[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[6].options.push(obj)
					})

				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			async StockReportStockExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await StockReportStockExport({
					cusGrade: this.from.cusGrade,
					cusName: this.from.cusName,
					inventory: this.from.inventory,
					batch: this.from.batch,
					invClass: this.from.invClass,
					isAboveZero: this.from.isAboveZero,
					ProvinceIDs: this.from.ProvinceID,
					SalesMan: this.from.SalesMan,
					ValiDate1: this.from.ValiDate1,
					ValiDate2: this.from.ValiDate2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `库存导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			StockExport() {
				this.StockReportStockExport()
			},
			async StockExportDay() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await StockReportStockDayExport({
					cusGrade: this.from.cusGrade,
					cusName: this.from.cusName,
					inventory: this.from.inventory,
					batch: this.from.batch,
					invClass: this.from.invClass,
					isAboveZero: this.from.isAboveZero,
					ProvinceIDs: this.from.ProvinceID,
					SalesMan: this.from.SalesMan,
					ValiDate1: this.from.ValiDate1,
					ValiDate2: this.from.ValiDate2,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				loading.close();
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `库存天数导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[5].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			reset() {
				this.$refs.invenselect.map((item, index) => {
					if (index == 8) {
						item.startTime = ""
						item.endTime = ""
					}
					item.modelvalue = ''
				})
				this.$refs.btngroup.checked = false
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			select() {
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata)
				}
				this.pageindex = 1
				try {
					console.log(this.$refs.btngroup.checkeds, 'this.$refs.btngroup.checked ');
					this.from.cusGrade = this.$refs.invenselect[0].modelvalue
					this.from.cusName = this.$refs.invenselect[1].modelvalue
					this.from.inventory = this.$refs.invenselect[3].modelvalue
					this.from.batch = this.$refs.invenselect[4].modelvalue
					this.from.invClass = this.$refs.invenselect[5].modelvalue ? this.$refs.invenselect[5].modelvalue.join(
						',') : ''
					this.from.isAboveZero = this.$refs.btngroup.checkeds ? 1 : 0
					this.from.ProvinceID = this.$refs.invenselect[6].modelvalue ? this.$refs.invenselect[6].modelvalue
						.join(',') : '';
					this.from.SalesMan = this.$refs.invenselect[7].modelvalue
					this.from.ValiDate1 = this.$refs.invenselect[8].startTime
					this.from.ValiDate2 = this.$refs.invenselect[8].endTime
					this.StockReportStockList()
				} catch (error) {
					this.StockReportStockList()
				}
			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},
			onRowClick(val) {
				this.selectedRow = val;
			},
			StockEdit() {
				if (!this.selectedRow) {
					this.$message.warning("请先选择要修改的数据！");
					return;
				}
				this.editFormFields = [
					{
						title: '产品型号',
						inputtype: 'input',
						types: 'text',
						disabled: true,
						width: '280px',
						lablewith: '100px',
						inputdata: this.selectedRow.InvAddCode || '',
						key: 'InvAddCode'
					},
					{
						title: '批号',
						inputtype: 'input',
						types: 'text',
						disabled: true,
						width: '280px',
						lablewith: '100px',
						inputdata: this.selectedRow.Batch || '',
						key: 'Batch'
					},
					{
						title: '生产日期',
						inputtype: 'dates',
						width: '280px',
						lablewith: '100px',
						inputdata: this.selectedRow.ManuDate ? this.selectedRow.ManuDate.split('T')[0].split(' ')[0] : '',
						key: 'ManuDate'
					},
					{
						title: '有效期至',
						inputtype: 'dates',
						width: '280px',
						lablewith: '100px',
						inputdata: this.selectedRow.ValiDate ? this.selectedRow.ValiDate.split('T')[0].split(' ')[0] : '',
						key: 'ValiDate'
					}
				];
				this.editDialogVisible = true;
			},
			async submitEdit() {
				const formData = {};
				if (this.$refs.editFormDropdowns) {
					this.editFormFields.forEach((field, index) => {
						const component = this.$refs.editFormDropdowns[index];
						formData[field.key] = component.modelvalue;
					});
				}
				if (!formData.ManuDate || !formData.ValiDate) {
					this.$message.warning("生产日期和有效期至不能为空！");
					return;
				}
				this.editLoading = true;
				try {
					let { code, message } = await StockReportEdit(formData);
					if (code == 0) {
						this.$message.success("修改成功");
						this.editDialogVisible = false;
						this.StockReportStockList();
					} else {
						this.$message.error(message || "修改失败");
					}
				} catch (error) {
					console.error(error);
					this.$message.error("修改异常");
				} finally {
					this.editLoading = false;
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.StockReportStockList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.StockReportStockList()
			},
		},
		// watch: {
		// 	showorhide: {
		// 		handler(newVal, oldVal) {
		// 			if (newVal == false) {
		// 				this.chackbox = false
		// 			} else {
		// 				this.chackbox = true
		// 			}
		// 		}
		// 	}
		// }
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 85px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all .3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 45px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all .3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 20px;
		width: 100%;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 44px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 30px;
	}
</style>